import { render, staticRenderFns } from "./ConfQuestionTile.vue?vue&type=template&id=350c0adc&scoped=true&"
import script from "./ConfQuestionTile.vue?vue&type=script&lang=js&"
export * from "./ConfQuestionTile.vue?vue&type=script&lang=js&"
import style0 from "./ConfQuestionTile.vue?vue&type=style&index=0&id=350c0adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c0adc",
  null
  
)

export default component.exports